import {NatGetLoginBeforeMessageList} from './NatGetLoginBeforeMessageList'
import {NatGetLoginBeforeMessage} from './NatGetLoginBeforeMessage'
import {NatPostLoginBeforeMessage, NatPostLoginBeforeMessageParams} from './NatPostLoginBeforeMessage'
import {NatPutLoginBeforeMessage, NatPutLoginBeforeMessageParams} from './NatPutLoginBeforeMessage'

import Http from '../../../../network/Http'
import {SortOrder} from '../../../../components/shared/SortOrder';
import {ContentType} from '../../../../network/Constants';
import {NatDeleteLoginBeforeMessage} from './NatDeleteLoginBeforeMessage';

// 検索条件
export interface SearchCondition {
    title?: string
    publishStartDatetime?: string
    publishEndDatetime?: string
}

// 検索条件（ページ情報）
export interface SearchConditionPageInfo {
    pageNum?: number
    page?: number
}

export default class NatLoginBeforeMessageRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // ログイン前メッセージマスタ取得
    async getLoginBeforeMessageMaster(loginBeforeMessageId: string): Promise<NatGetLoginBeforeMessage> {
        return await this.http.get(`/api/common/loginBeforeMessageMaster/${loginBeforeMessageId}`);
    }

    // ログイン前メッセージマスタ一覧取得
    async getLoginBeforeMessageMasterList(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfos?: SortOrder[],
    ):
        Promise<NatGetLoginBeforeMessageList> {
        const searchParams: string[] = [];
        if (searchCondition) {
            if (searchCondition.title) {
                searchParams.push(`title=${encodeURIComponent(searchCondition.title)}`);
            }
            if (searchCondition.publishStartDatetime) {
                searchParams.push(`publishStartDatetime=${encodeURIComponent(searchCondition.publishStartDatetime)}`);
            }
            if (searchCondition.publishEndDatetime) {
                searchParams.push(`publishEndDatetime=${encodeURIComponent(searchCondition.publishEndDatetime)}`);
            }
        }
        if (searchConditionSortInfos) {

            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                searchParams.push(`sortInfo=${value}`)
            })
        }

        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`);
            }
            if (searchConditionPageInfo.page) {
                searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`);
            }
        }
        const searchParamsText: string = searchParams.join('&');
        return await this.http.get(`/api/common/loginBeforeMessageMaster?${searchParamsText}`);
    }


    // ログイン前メッセージマスタ登録
    async postLoginBeforeMessage(request: NatPostLoginBeforeMessageParams): Promise<NatPostLoginBeforeMessage> {
        return await this.http.post(`/api/admin/loginBeforeMessageMaster`, {
                title: request.title,
                message: request.message,
            publishStartDatetime: request.publishStartDatetime,
            publishEndDatetime: request.publishEndDatetime,
            }, ContentType.JSON,
        )
    }

    // ログイン前メッセージマスタ更新
    async putLoginBeforeMessage(requestParam: NatPutLoginBeforeMessageParams): Promise<NatPutLoginBeforeMessage> {
        return await this.http.put('/api/admin/loginBeforeMessageMaster', requestParam)
    }

    // ログイン前メッセージマスタ削除
    async deleteLoginBeforeMessage(loginBeforeMessageId: string): Promise<NatDeleteLoginBeforeMessage> {
        return await this.http.delete(`/api/admin/loginBeforeMessageMaster/${loginBeforeMessageId}`);
    }

}
